import { render, staticRenderFns } from "./HistoryOweFeeImport.vue?vue&type=template&id=6b685ad9&scoped=true"
import script from "./HistoryOweFeeImport.vue?vue&type=script&lang=js"
export * from "./HistoryOweFeeImport.vue?vue&type=script&lang=js"
import style0 from "./HistoryOweFeeImport.vue?vue&type=style&index=0&id=6b685ad9&prod&lang=scss&scoped=true"
import style1 from "./HistoryOweFeeImport.vue?vue&type=style&index=1&id=6b685ad9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b685ad9",
  null
  
)

export default component.exports